export const PAGE_REQUEST = 'BILLING/PAGE_REQUEST';
export const GOT_NAMESPACES = 'BILLING/GOT_NAMESPACES';
export const GOT_BILLING_INFORMATION = 'BILLING/GOT_BILLING_FOR_NAMESPACE';
export const REMOVE_NAMESPACE = 'BILLING/REMOVE_NAMESPACE';
